import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';

// --- PWA Service Worker Registration & Web Vitals references ---
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // Import the service worker registration file
import reportWebVitals from './reportWebVitals'; // Import reportWebVitals
// --- END PWA IMPORTS ---

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// --- PWA SERVICE WORKER REGISTRATION ---
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register(); // <--- This line registers your PWA service worker

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); // Keep this if you want web vitals reporting
// --- END PWA SERVICE WORKER REGISTRATION ---